import React, { Component } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

import { withUser } from '../../../components/Utils';
import configs from '../../../routes'
import { getConfigsDinamic } from '../../../routes/sistema/DinamicForms/functions'
import { temPermissao } from '../../../modules/permissoes/functions'

const mapStateToProps = (state, props) => {
    const { CustomConfigs, CustomFormDeveloperReducer } = state;

    const rotas = []

    addRotas(configs, rotas);

    if (CustomConfigs) {
        let forms = CustomConfigs.rListaCustomForm.lista;
        addRotas(criaConfigCustomForms(forms), rotas)

    }
    if (CustomFormDeveloperReducer)
        addRotas(criaConfigCustomForms(CustomFormDeveloperReducer.rListaCustonFormPermitidos.lista), rotas)

    const configDinamic = getConfigsDinamic(state);
    if (configDinamic) {
        addRotas(configDinamic, rotas)
    }
    return { rotas };
};


export default compose(
    withUser,
    connect(mapStateToProps, {})

);


function addRotas(configs, rotas) {
    if (configs.route) {

        rotas.push(<RouteWithSubRoutes key={configs.route.path} {...configs.route} />)
    }
    if (configs.subConfig) {
        configs.subConfig.forEach(((sub, i) => addRotas(sub, rotas)))
    }
}

function RouteWithSubRoutes(route) {
    if (route.permissao) {
        let per = temPermissao(route.permissao)
        if (per !== null && !per) {
            return <Redirect to={"/"} />
        }
    }

    return (
        <Route
            path={route.path}
            exact={route.exact ? true : false}
            render={props => (
                <route.component {...props} routes={route.routes} {...route.props} />
            )}
        />
    );
}


// WEBPACK FOOTER //
// ./src/App/components/ViewerRoutes/ViewerRoutes.enhancer.js